import publicationAsset from "@/assets/publication-social-2026.jpg.asset.json";
import { SITE_URL, ogImage } from "@/lib/seo";

export const PUBLICATION_SHARE_IMAGE = `${SITE_URL}${publicationAsset.url}`;
export const HOME_SHARE_TITLE = "Akıllı Sürdürülebilirlik — İklim, teknoloji, ekonomi ve insan üzerine bağımsız yayın";
export const HOME_SHARE_DESCRIPTION = "İklim, teknoloji, ekonomi ve insan üzerine eleştirel düşünce. Dünyanın değişimini ve bu değişimin insan için ne anlama geldiğini sorgulayan bağımsız yayın.";

/** Preserve the original cover; use approved publication artwork only without one. */
export function shareImage(cover?: string | null): string {
  const image = ogImage(cover);
  return image.startsWith("https://") ? image : PUBLICATION_SHARE_IMAGE;
}

export function socialImageMeta(cover?: string | null) {
  const image = shareImage(cover);
  return [
    { property: "og:image", content: image },
    { name: "twitter:image", content: image },
    { name: "twitter:card", content: "summary_large_image" },
  ];
}